module.exports = __webpack_public_path__ + "img/switchdb.fbd92f05.png";